/* eslint-disable */
import React, { useState } from "react";
import PropTypes from "prop-types";
import LoadingIcon from "../loading/LoadingIcon";
import styled from "styled-components";
import FwdButtonIcon from "../../../assets/images/spotify/FwdButtonImg.svg";
import PlayButton from "../../../assets/images/spotify/PlayButtonImg.svg";
import PauseButtonIcon from "../../../assets/images/spotify/PauseButtonImg.svg";
import { setAlert, setBoxShadow, setColor, setFont } from "../../../assets/styles/styles";
import Iconify from "../icon/Iconify";
import { NavLink } from "react-router-dom";

/**
 * Primary UI component for user interaction
 */
const Button = ({
    variant,
    backgroundColor,
    label,
    showMessage,
    error,
    margin,
    success,
    iconCenter,
    iconRight,
    iconLeft,
    iconSize,
    buttonWidth,
    buttonMobileWidth,
    iconTransition,
    labelColor,
    onHoverColor,
    iconColor,
    boxShadow,
    border,
    lowercase,
    disabled,
    isPaused,
    handleSpotifyPause,
    customIcon,
    customIconMargin,
    iconMargin,
    height,
    style,
    isActivated,
    borderRadius,
    fontSize,
    id,
    loading,
    ...props
}) => {
    const [onHover, setOnHover] = useState(false);

    const ButtonComponent = Button.variants[variant] || Button.variants["DefaultButton"];

    return (
        <>
            {showMessage && (
                <MessageStyle success={success} error={error}>
                    <p>{showMessage}</p>
                </MessageStyle>
            )}
            {variant === "SpotifyButtons" ? (
                <PlayButtonsContainer landscape={props.landscape}>
                    <FwdButton
                        src={FwdButtonIcon}
                        alt="Fwd Button"
                        // onClick={() => handleSpotifyNext()}
                    />
                    <PauseButton
                        src={isPaused ? PlayButton : PauseButtonIcon}
                        alt="Pause Button"
                        //    onClick={() => handleSpotifyPause()}
                    />
                </PlayButtonsContainer>
            ) : variant === "otherButton" ? (
                <PlayButtonsContainer landscape={props.landscape}></PlayButtonsContainer>
            ) : (
                <ButtonComponent
                    {...props}
                    fontSize={fontSize}
                    // onClick={() => setLoading(true)}
                    onMouseOver={() => setOnHover(true)}
                    onMouseOut={() => setOnHover(false)}
                    buttonWidth={buttonWidth}
                    buttonMobileWidth={buttonMobileWidth}
                    backgroundColor={backgroundColor}
                    labelColor={labelColor}
                    $onHoverColor={onHoverColor}
                    iconColor={iconColor}
                    margin={margin}
                    boxShadow={boxShadow}
                    border={border}
                    disabled={disabled || loading}
                    style={style}
                    isActivated={isActivated}
                    borderRadius={borderRadius}
                    id={id}
                    iconMargin={iconMargin}
                >
                    {iconLeft && (
                        <Iconify
                            icon={iconLeft}
                            size={iconSize}
                            iconMargin={iconMargin ? iconMargin : "0px 10px 0px 0px"}
                            iconTransition={iconTransition}
                            Color={
                                onHover && onHoverColor !== null
                                    ? onHoverColor
                                    : onHover && onHoverColor === null
                                      ? setColor.accent1
                                      : iconColor !== null && !onHover
                                        ? iconColor
                                        : setColor.textPrimary
                            }
                        />
                    )}

                    {iconCenter && (
                        <Iconify
                            icon={iconCenter}
                            size={iconSize}
                            iconMargin={iconMargin ? iconMargin : "0px"}
                            iconTransition={iconTransition}
                            Color={
                                onHover && onHoverColor !== null
                                    ? onHoverColor
                                    : onHover && onHoverColor === null
                                      ? setColor.accent1
                                      : iconColor !== null && !onHover
                                        ? iconColor
                                        : setColor.textPrimary
                            }
                        />
                    )}

                    {customIcon && (
                        <img
                            src={customIcon}
                            alt="customIcon"
                            style={{
                                margin: customIconMargin ? customIconMargin : "5px",
                                color: backgroundColor ? labelColor : "white",
                                cursor: "default",
                                height: iconSize ? iconSize : "20px",
                                width: iconSize ? iconSize : "20px",
                            }}
                        />
                    )}

                    {loading ? (
                        <LoadingIconContainer>
                            <LoadingIcon />
                        </LoadingIconContainer>
                    ) : (
                        label
                    )}

                    {iconRight && (
                        <Iconify
                            icon={iconRight}
                            size={iconSize}
                            iconMargin={iconMargin ? iconMargin : "0px 0px 0px 10px"}
                            Color={
                                onHover && onHoverColor !== null
                                    ? onHoverColor
                                    : onHover && onHoverColor === null
                                      ? setColor.accent1
                                      : iconColor !== null && !onHover
                                        ? iconColor
                                        : setColor.textPrimary
                            }
                        />
                    )}
                </ButtonComponent>
            )}
        </>
    );
};

export default Button;

Button.variants = {
    DefaultButton: styled.button`
        padding: 10px 30px;
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
        cursor: pointer;
        display: inline-block;
        line-height: 1;
        height: auto;
        min-height: 58px;
        margin: ${(props) => props.margin};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "fit-content")};
        font-size: 1.125rem;
        color: ${(props) => (props.labelColor ? props.labelColor : setColor.accent4)};
        background: ${setColor.onHoverTextcolor2} !important;
        /* background-color: black; */
        border: ${(props) => (props.border != null ? `1px solid  ${props.border}` : "transparent")};
        transition: 0.3s;
        box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : setBoxShadow.default)};
        font-family: ${setFont.barlow};
        font-weight: 700;
        text-transform: uppercase;
        :hover {
            transition: 0.3s;
            background: ${() => `${setColor.accent4} !important`};
            color: ${(props) => (props.onHoverColor ? props.onHoverColor : setColor.onHoverTextcolor2)};
        }
        :active {
            background: ${() => `${setColor.accent4} !important`};
            color: ${(props) => (props.onHoverColor ? props.onHoverColor : setColor.onHoverTextcolor2)};
        }
        @media (max-width: 768px) {
            font-size: 16px;
            height: auto;
            min-height: 0;
            padding: 14px;
        }

        @media (max-width: 320px) {
            font-size: 16px;
            height: auto;
            width: 100%;
            padding: 14px;
        }
    `,
    OutlinedButton: styled.button`
        border: ${(props) => (props.border != null ? `2px solid ${props.border}` : `2px solid${setColor.iconColor3}`)};
        padding: ${(props) => (props.padding ? props.padding : "10px 45px")};
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
        cursor: pointer;
        display: inline-block;
        line-height: 1;
        height: ${(props) => (props.height ? props.height : "auto")};
        min-height: 58px;
        margin: ${(props) => props.margin};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "fit-content")};
        font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
        color: ${(props) => (props.labelColor ? props.labelColor : setColor.iconColor3)};
        background: transparent;
        background: ${(props) =>
            props.backgroundColor ? props.backgroundColor : props.disabled ? setColor.grey1 : "transparent"};
        transition: 0.3s;
        box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : setBoxShadow.default)};
        font-family: ${setFont.barlow};
        font-weight: 700;
        text-transform: ${(props) => (props.lowercase !== false ? "none" : "uppercase")};
        letter-spacing: ${(props) => (props.letterSpacing ? props.letterSpacing : "normal")};

        ${(props) =>
            !props.disableHover &&
            `
            &:hover {
                transition: 0.3s;
                background-color: transparent !important;
                color: ${props.onHoverColor ? props.onHoverColor : setColor.iconColor3};
            }
        `}

        @media (max-width: 768px) {
            font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
            height: auto;
            min-height: 40px;
            padding: 14px;
            width: 100%;
            letter-spacing: 1px;
        }

        @media (max-width: 320px) {
            font-size: 16px;
            height: auto;
            width: 100%;
            padding: 14px;
        }
    `,
    PinkButton: styled.button`
        padding: 10px 45px;
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
        cursor: pointer;
        display: inline-block;
        line-height: 1;
        height: auto;
        min-height: 50px;
        padding: ${(props) => props.padding};
        margin: ${(props) => props.margin};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "fit-content")};
        font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
        color: ${(props) =>
            props.labelColor ? props.labelColor : props.disabled ? setColor.iconColor : setColor.inputText};
        background: ${(props) => (props.disabled ? setColor.grey1 : setColor.pinkButtonBgGradient)};
        border: ${(props) => (props.border != null ? `1px solid  ${props.border}` : "transparent")};
        transition: 0.3s;
        box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : setBoxShadow.default)};
        font-family: ${setFont.barlow};
        font-weight: 700;
        text-transform: uppercase;

        ${(props) =>
            !props.disabled &&
            `:hover {
                transition: 0.3s;
                background-color: ${props.disabled ? "grey" : `${setColor.grey1} !important`};
                color: ${props.onHoverColor ? props.onHoverColor : setColor.secondary};
        }`}

        @media (max-width: 768px) {
            font-size: 16px;
            height: 54px;
            min-height: 50px;
            min-width: 100%;
            padding: 14px;
        }

        @media (max-width: 320px) {
            font-size: 16px;
            height: auto;
            width: 100%;
            padding: 14px;
        }
    `,

    PurpleButton: styled.button`
        padding: 10px 45px;
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
        cursor: pointer;
        display: inline-block;
        line-height: 1;
        height: auto;
        min-height: 50px;
        padding: ${(props) => props.padding};
        margin: ${(props) => props.margin};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "fit-content")};
        font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
        color: ${(props) =>
            props.labelColor ? props.labelColor : props.disabled ? setColor.iconColor : setColor.inputText};
        background: ${(props) =>
            props.disabled ? setColor.grey1 : props.backgroundColor ? props.backgroundColor : setColor.brightViolet};
        border: ${(props) => (props.border != null ? `1px solid  ${props.border}` : "transparent")};
        transition: 0.3s;
        box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : setBoxShadow.default)};
        font-family: ${setFont.barlow};
        font-weight: 700;
        letter-spacing: 0.5px;

        ${(props) =>
            !props.disabled &&
            `:hover {
                transition: transform 0.3s ease; /* Smooth scaling effect */
                transform: scale(1.05);
        }`}

        @media (max-width: 768px) {
            font-size: 16px;
            height: 54px;
            min-height: 50px;
            // min-width: ${(props) => (props.buttonWidth ? props.buttonWidth : "100%")};
            width: ${(props) => (props.buttonMobileWidth ? props.buttonMobileWidth : "100%")};
            padding: 14px;
        }

        @media (max-width: 320px) {
            font-size: 16px;
            height: auto;
            width: 100%;
            padding: 14px;
        }
    `,
    VanityLinkCustomizable: styled.button`
        border: ${(props) =>
            props.border ? `1px solid ${props.border}` : props.disabled ? "none" : `2px solid ${setColor.accent4}`};
        padding: 10px 45px;
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "0px")};
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 1;
        letter-spacing: normal;
        height: ${(props) => (props.height ? props.height : "auto")};
        min-height: 58px;
        margin: ${(props) => (props.margin ? props.margin : "1rem 0rem")};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "100%")};
        font-size: 16px;
        color: ${(props) => (props.labelColor ? props.labelColor : props.disabled ? "#9DA0A7" : setColor.accent4)};
        background: ${(props) =>
            props.backgroundColor
                ? props.backgroundColor
                : props.disabled
                  ? setColor.grey1
                  : setColor.purpleBackground};
        transition: 0.3s;
        box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : setBoxShadow.default)};
        font-family: ${setFont.barlow};
        font-weight: 700;
        c :hover {
            transition: 0.3s;
            background-color: ${(props) => (props.disabled ? setColor.grey1 : `transparent !important`)};
            color: ${(props) =>
                props.onHoverColor ? props.onHoverColor : props.disabled ? "white" : setColor.accent4};
        }

        @media (max-width: 768px) {
            font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
            height: auto;
            min-height: 65px;
            padding: 14px;
            width: 100%;
        }

        @media (max-width: 320px) {
            font-size: 16px;
            height: auto;
            width: 100%;
            padding: 14px;
        }
    `,
    DisabledButton: styled.button`
        border: none;
        padding: 10px 45px;
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "0px")};
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 1;
        height: ${(props) => (props.height ? props.height : "auto")};
        min-height: 58px;
        margin: ${(props) => (props.margin ? props.margin : "1rem 0rem")};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "100%")};
        font-size: 16px;
        color: #9da0a7;
        background: ${setColor.grey1};
        transition: 0.3s;
        box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : setBoxShadow.default)};
        font-family: ${setFont.barlow};
        font-weight: 700;
        text-transform: uppercase;
        :hover {
            transition: 0.3s;
            background-color: ${setColor.grey1};
            color: white;
        }

        @media (max-width: 768px) {
            font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
            height: auto;
            min-height: 65px;
            padding: 14px;
            width: 100%;
        }

        @media (max-width: 320px) {
            font-size: 16px;
            height: auto;
            width: 100%;
            padding: 14px;
        }
    `,
    NavigationButton: styled(NavLink)`
        text-decoration: none;
        border: 1px solid var(--purple-purple-20, ${setColor.purpleNavigation});
        padding: 5px 20px;
        border-radius: 5px;
        cursor: pointer;
        display: inline-block;
        letter-spacing: 1.5px;
        height: ${(props) => (props.height ? props.height : "auto")};
        margin: ${(props) => props.margin};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "fit-content")};
        font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
        color: var(--Text-Light-Grey, ${setColor.iconColor});
        background: transparent;
        transition: 0.3s;
        font-family: ${setFont.barlow};
        font-weight: 700;
        text-transform: uppercase;

        &.active {
            background: ${setColor.iconColor3};
            color: var(--bg-primary-100, ${setColor.inputBgColor});
        }

        @media (max-width: 768px) {
            font-size: ${(props) => (props.fontSize ? props.fontSize : "14px")};
            font-weight: 800;
        }

        @media (max-width: 320px) {
            font-size: 16px;
            height: auto;
            width: 100%;
            padding: 10px 20px;
        }
    `,
    PurpleArrowButton: styled.button`
        border: ${(props) => (props.border != null ? `2px solid ${props.border}` : `none`)};
        padding: ${(props) => (props.padding ? props.padding : "25px 25px")};
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 1;
        height: ${(props) => (props.height ? props.height : "auto")};
        min-height: ${(props) => (props.minHeight ? props.minHeight : "58px")};
        text-align: left;
        margin: ${(props) => props.margin};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "fit-content")};
        font-size: ${(props) => (props.fontSize ? props.fontSize : "24px")};
        color: ${(props) => (props.labelColor ? props.labelColor : "#FBFCFF")};
        background: ${(props) => (props.backgroundColor ? props.backgroundColor : "#20162E")};
        transition: 0.3s;
        box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : setBoxShadow.default)};
        font-family: ${setFont.barlow};
        font-weight: 600;
        letter-spacing: ${(props) => (props.letterSpacing ? props.letterSpacing : "none")};
        :hover {
            transition: 0.3s;
            color: ${(props) => (props.onHoverColor ? props.onHoverColor : setColor.iconColor3)};
        }

        @media (max-width: 768px) {
            font-size: ${(props) => (props.fontSize ? props.fontSize : "18px")};
            height: auto;
            min-height: 40px;
            padding: 14px;
            width: 100%;
            letter-spacing: 1px;
        }

        @media (max-width: 320px) {
            font-size: 16px;
            height: auto;
            width: 100%;
            padding: 14px;
        }
    `,
    SmallButton: styled.button`
        padding: 10px;
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
        cursor: pointer;
        display: inline-block;
        line-height: 1;
        height: auto;
        margin: ${(props) => props.margin};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "fit-content")};
        font-size: 12px;
        color: ${(props) => (props.labelColor ? props.labelColor : setColor.accent4)};
        background: ${setColor.onHoverTextcolor2} !important;
        /* background-color: black; */
        border: ${(props) => (props.border != null ? `1px solid  ${props.border}` : "transparent")};
        transition: 0.3s;
        box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : setBoxShadow.default)};
        font-family: ${setFont.barlow};
        font-weight: 700;
        text-transform: uppercase;
        :hover {
            transition: 0.3s;
            background: ${() => `${setColor.accent4} !important`};
            color: ${(props) => (props.onHoverColor ? props.onHoverColor : setColor.onHoverTextcolor2)};
        }
        :active {
            background: ${() => `${setColor.accent4} !important`};
            color: ${(props) => (props.onHoverColor ? props.onHoverColor : setColor.onHoverTextcolor2)};
        }
        @media (max-width: 768px) {
            font-size: 10px;
            height: auto;
            min-height: 0;
            padding: 14px;
        }

        @media (max-width: 320px) {
            font-size: 10px;
            height: auto;
            width: 100%;
            padding: 14px;
        }
    `,
    SmallButtonGrey: styled.button`
        padding: 10px;
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
        cursor: pointer;
        display: inline-block;
        line-height: 1;
        height: auto;
        margin: ${(props) => props.margin};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "fit-content")};
        font-size: 12px;
        color: ${setColor.circularProgress};
        background: #beaeff1a;
        border: ${(props) => (props.border != null ? `1px solid  ${props.border}` : "transparent")};
        font-family: ${setFont.barlow};
        font-weight: 700;
        text-transform: uppercase;
        @media (max-width: 768px) {
            font-size: 10px;
            height: auto;
            min-height: 0;
            padding: 14px;
        }

        @media (max-width: 320px) {
            font-size: 10px;
            height: auto;
            width: 100%;
            padding: 14px;
        }
    `,
    SmallButtonPurple: styled.button`
        padding: 10px;
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
        cursor: pointer;
        display: inline-block;
        height: auto;
        margin: ${(props) => props.margin};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "fit-content")};
        font-size: 16px;
        background: rgba(157, 117, 245, 0.2);
        color: white;
        border: ${(props) => (props.border != null ? `1px solid  ${props.border}` : "transparent")};
        font-family: ${setFont.barlow};
        font-weight: bold;
        letter-spacing: 1px;

        @media (max-width: 768px) {
            font-size: 15px;
            height: auto;
            min-height: 0;
            padding: 14px;
        }

        @media (max-width: 320px) {
            font-size: 15px;
            height: auto;
            width: 100%;
            padding: 14px;
        }
    `,

    TextButton: styled.button`
        background-color: transparent;
        color: white;
        border: none;
        cursor: pointer;
        font-size: 16px;
        text-transform: uppercase;
        padding: 10px;
        font-family: ${setFont.barlow};
        font-weight: 700;

        &:hover {
            color: ${(props) => (props.onHoverColor ? "white" : setColor.accent4)};
            background-color: ${(props) =>
                props.onHoverColor ? setColor.brightVioletTransparent10 : "transparent"}; /* Optional hover effect */
        }

        &:disabled {
            color: ${setColor.grey1}; /* Optional disabled state */
            cursor: not-allowed;
        }
    `,

    LandingHeaderButton: styled.button`
        padding: 10px 45px;
        border-radius: ${(props) => (props.borderRadius ? props.borderRadius : "5px")};
        cursor: pointer;
        display: inline-block;
        line-height: 1;
        height: auto;
        min-height: 50px;
        padding: ${(props) => props.padding};
        margin: ${(props) => props.margin};
        width: ${(props) => (props.buttonWidth ? props.buttonWidth : "fit-content")};
        font-size: ${(props) => (props.fontSize ? props.fontSize : "16px")};
        color: ${(props) =>
            props.labelColor ? props.labelColor : props.disabled ? setColor.iconColor : setColor.inputText};
        background: ${(props) => (props.disabled ? setColor.grey1 : setColor.pinkButtonBgGradient)};
        border: ${(props) => (props.border != null ? `1px solid  ${props.border}` : "transparent")};
        transition: 0.3s;
        box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : setBoxShadow.default)};
        font-family: ${setFont.barlow};
        font-weight: 700;
        text-transform: uppercase;

        ${(props) =>
            !props.disabled &&
            `:hover {
                transition: 0.3s;
                background: ${props.disabled ? "grey" : `${setColor.pinkButtonBgGradient70} !important`};
        }`}
    `,
};

Button.propTypes = {
    variant: PropTypes.oneOf([
        "DefaultButton",
        "OutlinedButton",
        "PinkButton",
        "SpotifyButtons",
        "SmallButton",
        "SmallButtonGrey",
        "SmallButtonPurple",
        "PurpleButton",
        "VanityLinkCustomizable",
        "DisabledButton",
        "NavigationButton",
        "PurpleArrowButton",
        "TextButton",
        "LandingHeaderButton",
        "otherButton", // if used anywhere
    ]),
    backgroundColor: PropTypes.string,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    /**
     * Show message if trigger was successful or error
     */
    showMessage: PropTypes.string,
    /**
     * Shows red text
     */
    error: PropTypes.bool,
    /**
     * Shows green text
     */
    success: PropTypes.bool,
    /**
     * Shows icon in either side, or both sides
     */
    iconLeft: PropTypes.string,
    iconRight: PropTypes.string,
    iconCenter: PropTypes.string,
    iconSize: PropTypes.string,
    /**
     * Slides Icon from left to right on Horizontal, and size adjusts the icon height
     */
    buttonWidth: PropTypes.string,
    margin: PropTypes.string,
    boxShadow: PropTypes.string,
    disabled: PropTypes.bool,
    isPaused: PropTypes.bool,
    customIcon: PropTypes.node,
    customIconMargin: PropTypes.string,
    style: PropTypes.object,
    borderRadius: PropTypes.string,
    id: PropTypes.string,
};

const MessageStyle = styled.div`
    color: ${(props) => (props.error ? setAlert.danger : props.success ? setAlert.success : setColor.textPrimary)};
    padding: 20px;
    font-family: ${setFont.barlow};
`;
const LoadingIconContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;
const PlayButtonsContainer = styled.div`
    display: flex;
    align-items: stretch;
    padding-top: 10px;
    margin-right: 1.5rem;
    height: 150px;
    width: 150px;

    @media (max-width: 425px) {
        flex-direction: ${(props) => (props.landscape ? "row" : "column-reverse")};
        padding: 5px;
        align-items: center;
        justify-content: center;
        padding-top: 0px;
    }
`;

const FwdButton = styled.img`
    flex: 1;
    height: 100%;
    padding: 10px 0 10px 0;
    margin-left: 5px;
    border: none;
    cursor: pointer;
    /* height: 150px; */
    width: 150px;

    @media (max-width: 960px) {
        padding: 5px 0 0 10px;
    }
    @media (max-width: 425px) {
        /* padding: 5px 0 0 0; */
    }
`;
const PauseButton = styled.img`
    height: 100%;
    flex: 1;
    padding: 5px;
    padding: 5px 5px 5px 0;
    /* margin-left: 5px; */
    margin-right: 10px;
    border: none;
    cursor: pointer;

    @media (max-width: 960px) {
        padding: 0 10px 0 0;
    }
    @media (max-width: 425px) {
        margin-right: 0px;
        padding: 5px 0 0 0;
    }
`;
